import { createContext } from 'react';

interface FlyoutContextValue {
   titleId: string;
   closeOnOutsideClick: boolean;
   position: 'right' | 'left' | 'bottom';
   isOpen: boolean;
   onClose?: () => void;
}

export const FlyoutContext = createContext<FlyoutContextValue>({
   titleId: '',
   closeOnOutsideClick: false,
   position: 'right',
   isOpen: false,
   onClose: undefined
});
